class FaqComponent extends HTMLElement {
  constructor() {
    super()

    this.querySelectorAll('.faq-item__question').forEach((question) => {
      const answer = question.nextElementSibling
      if (answer && !question.classList.contains('active')) {
        answer.setAttribute('inert', '')
      }
      question.addEventListener('click', this.onFaqClick.bind(this))
    })
  }

  setExpanded(question, expanded) {
    const answer = question.nextElementSibling
    question.classList.toggle('active', expanded)
    question.setAttribute('aria-expanded', String(expanded))
    if (!answer) return
    if (expanded) {
      answer.removeAttribute('inert')
    } else {
      answer.setAttribute('inert', '')
    }
  }

  onFaqClick(event) {
    const question = event.currentTarget
    const isOpen = question.classList.contains('active')

    if (isOpen) {
      this.setExpanded(question, false)
      return
    }

    const isAccordionCollectionList = this.closest('.accordion-collection-list-wrapper')

    if (isAccordionCollectionList) {
      this.querySelectorAll('.faq-item__question.active').forEach((activeQuestion) => {
        this.setExpanded(activeQuestion, false)
      })
    }

    this.setExpanded(question, true)
  }
}

if (!customElements.get('faq-component')) {
  customElements.define('faq-component', FaqComponent)
}
